import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { KozDokumentStavka } from './koz-dokument-stavka';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-koz-dokument-stavka-update',
  templateUrl: './koz-dokument-stavka-update.component.html'
})
export class KozDokumentStavkaUpdateComponent extends BaseUpdateComponent<KozDokumentStavka> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Brfak',Validators.required, 'required', 'KOZDOKUMENTSTAVKA.BRFAK.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datfak',Validators.required, 'required', 'KOZDOKUMENTSTAVKA.DATFAK.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datdpo',Validators.required, 'required', 'KOZDOKUMENTSTAVKA.DATDPO.VALIDATION.REQUIRED');
    this.addValidatorToFc('Iznos',Validators.required, 'required', 'KOZDOKUMENTSTAVKA.IZNOS.VALIDATION.REQUIRED');
  }

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}

}